import * as React from 'react';
import getHtmlDataSet from 'Utils/GetHtmlDataSet';

// Components
import CoursesListInstructorPage from '../../Instructor/Containers/CoursesListInstructorPage';
import CoursesListStudentPage from '../../Student/Containers/CoursesListStudentPage';

export default class CoursesListPage extends React.Component<{}, {}> {
    public render() {
        switch (getHtmlDataSet().mode) {
            case 'I':
                return <CoursesListInstructorPage/>;
            default:
                return <CoursesListStudentPage/>;
        }
    }
}
